exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hec-saving[data-v-6d85c8ce] {\n    margin-bottom: 20px!important;\n}\n", ""]);

// exports
